const AUTH_PATHS = {
  signIn: {
    name: '帳號登入',
    pathname: '/sign-in',
    icon: null,
  },
  signUp: {
    name: '帳戶註冊',
    pathname: '/sign-up',
    icon: null,
  },
  activateAccount: {
    name: '帳戶啟用',
    pathname: '/activate-account',
    icon: null,
  },
  forgotPassword: {
    name: '忘記密碼',
    pathname: '/forgot-password',
    icon: null,
  },
  resetPassword: {
    name: '密碼變更',
    pathname: '/reset-password',
    icon: null,
  },
  authEmailAction: {
    name: 'Auth Email Action',
    pathname: '/auth-email-action',
    icon: null,
  },
} as const;

export default AUTH_PATHS;
